import React from 'react';

const FinancialPlanningSingleParentsBottomline = () => {
  const benefits = [
    {
      title: "Extended Safety Net Creation",
      description: "Establishing a more robust emergency fund (9-12 months of expenses) creates financial stability during income disruptions, healthcare challenges, or unexpected household expenses that single-income families are particularly vulnerable to."
    },
    {
      title: "Guardian-Focused Estate Planning",
      description: "Implementing comprehensive legal structures including guardianship designations, trusts, and detailed care instructions ensures your children's financial and personal wellbeing continues according to your wishes regardless of circumstances."
    },
    {
      title: "Strategic Time Management",
      description: "Simplifying financial systems through automation, consolidation, and professional support allows you to maximize your limited time while still maintaining control over critical financial decisions that impact your family."
    },
    {
      title: "Targeted Tax Advantage Utilization",
      description: "Leveraging head-of-household status, dependent care credits, and other tax benefits specifically available to single parents significantly reduces tax burden, effectively increasing your disposable income without changing your earnings."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic Single Parent Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-[#F49611] opacity-10">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancialPlanningSingleParentsBottomline;